// Single source of truth for the Robvision tunables that span helpers,
// the upload dialog, and the labeling tool. Backend payload limits and
// UI-side validation share these so changing one place updates all
// dependent error messages and disabled states.

// SAM ViT-based encoders ingest images up to ~1920px on the long side;
// larger images are downsampled to keep the in-browser embedding pass viable.
export const MAX_INFERENCE_DIM = 1920;

// Upload-dialog limits. The byte ceiling is what the backend accepts per
// image; MAX_FILE_MB exists so the user-visible error string can be
// generated from MAX_FILE_BYTES instead of repeating the literal.
export const MAX_IMAGES = 15;
export const MAX_FILE_MB = 15;
export const MAX_FILE_BYTES = MAX_FILE_MB * 1024 * 1024;

// Optional deployment-environment background images uploaded at project
// creation; mirrors MAX_CUSTOM_BACKGROUNDS in the backend.
export const MAX_BACKGROUND_IMAGES = 20;

// LabelingTool hit-test and OBB handle geometry, in CSS pixels (divided
// by zoom at use-sites so handles stay the same screen size at any zoom).
export const POINT_HIT_RADIUS = 8;
export const OBB_HANDLE_SIZE = 8;
export const OBB_KNOB_OFFSET = 24;
export const OBB_KNOB_RADIUS = 6;
